import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { PersonCategoryService } from '../proxy/general/controllers/person-category.service';
// TODO: Import required services for Foreign Keys
// import { ResourceTypeService } from '../proxy/general/controllers/resource-type.service';

FieldBuilder.setNamespace('General');

export const PERSONCATEGORYMAPPINGBIOFOREST_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('personCategoryId', 'Entity.PersonCategory', PersonCategoryService)
    .required()
    .displayFromNested('personCategory.name')
    .sortBy('personCategory.name')
    .build(),
  // TODO: ResourceTypeId is a Foreign Key - References ResourceType entity
  // Uncomment and configure after importing ResourceTypeService:
  // FieldBuilder
  //   .foreignKey('resourceTypeId', 'Entity.ResourceType', ResourceTypeService)
  //   .required()
  //   .display('name')  // Adjust display field if needed
  //   .keyField('id')   // Adjust key field if needed
  //   .build(),
];

export const PERSONCATEGORYMAPPINGBIOFOREST_CONFIG = {
  entityName: 'PersonCategoryMappingBioforest',
  localizationKey: 'General::Entity.PersonCategoryMappingBioforest',
  fields: PERSONCATEGORYMAPPINGBIOFOREST_FIELDS,
  permission: 'ControllingStructural.PersonCategoryMappingBioForests',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Structural + MENU_NAME_SUFFIX,
};
